import { render, staticRenderFns } from "./sightingslocdash.vue?vue&type=template&id=55867004"
import script from "./sightingslocdash.vue?vue&type=script&lang=js"
export * from "./sightingslocdash.vue?vue&type=script&lang=js"
import style0 from "./sightingslocdash.vue?vue&type=style&index=0&id=55867004&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports